import { LockOutlined } from '@ant-design/icons';
import { App, Button, Card, Col, Row, Space, Switch, Typography } from 'antd';
import { useEffect, useState } from 'react';
import {
  type LoginMethodsConfig,
  fetchAdminLoginMethods,
  saveAdminLoginMethods,
} from '../../api/system-config.js';

const { Text, Title } = Typography;

export function SystemConfigPage() {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [config, setConfig] = useState<LoginMethodsConfig>({
    passwordLoginEnabled: true,
    dingtalkLoginEnabled: true,
  });

  useEffect(() => {
    let active = true;
    setLoading(true);
    void fetchAdminLoginMethods()
      .then((data) => {
        if (active) setConfig(data);
      })
      .catch((err) => {
        const e = err as { response?: { data?: { message?: string } }; message?: string };
        const msg = e?.response?.data?.message ?? e?.message ?? '读取系统配置失败';
        void message.error(msg);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [message]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const next = await saveAdminLoginMethods({
        passwordLoginEnabled: config.passwordLoginEnabled,
      });
      setConfig(next);
      void message.success('登录方式配置已保存');
    } catch (err) {
      const e = err as { response?: { data?: { message?: string } }; message?: string };
      const msg = e?.response?.data?.message ?? e?.message ?? '保存系统配置失败';
      void message.error(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <div>
        <Title level={4} style={{ margin: 0 }}>
          系统配置
        </Title>
        <Text type="secondary">配置系统级能力开关，变更保存后立即影响后续用户访问。</Text>
      </div>

      <Card
        title={
          <Space>
            <LockOutlined />
            <span>登录方式配置</span>
          </Space>
        }
        loading={loading}
        extra={
          <Button type="primary" loading={saving} onClick={() => void handleSave()}>
            保存配置
          </Button>
        }
      >
        <Row gutter={[24, 16]}>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={8}>
              <Space>
                <Switch
                  checked={config.passwordLoginEnabled}
                  onChange={(checked) =>
                    setConfig((prev) => ({ ...prev, passwordLoginEnabled: checked }))
                  }
                />
                <Text strong>账户密码登录</Text>
              </Space>
              <Text type="secondary">
                当前登录页仅展示钉钉一键登录；此开关只控制后端账户密码登录接口是否接受请求。
              </Text>
            </Space>
          </Col>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={8}>
              <Space>
                <Switch checked={config.dingtalkLoginEnabled} disabled />
                <Text strong>钉钉一键登录</Text>
              </Space>
              <Text type="secondary">钉钉登录为当前系统保底登录方式，暂不支持在此页面关闭。</Text>
            </Space>
          </Col>
        </Row>
      </Card>
    </Space>
  );
}
